module.exports = __webpack_public_path__ + "ee80dcf7a5a7d52d31e6f955e208bee8.webp";